import Vue from 'vue';
import { Puzzle } from 'js/crossword/Puzzle';
import { getCurrentClue } from 'js/crossword/puzzleDataHandlers/helpers';
import { Provider } from "../types";
import ResizeObserver from 'resize-observer-polyfill';
import OS from 'framework/utils/OS';

Vue.component('current-clue-bar', {
  inject: [Provider.LOCALIZATION],
  data() {
    return {
      resizeObserver: new ResizeObserver(() => this.resize()),
      leftAnimated: false,
      rightAnimated: false,
    };
  },
  props: {
    puzzle: Puzzle,
    hidden: Boolean,
  },
  mounted() {
    this.resizeObserver.observe(this.$refs.textContainer as HTMLElement);
    this.resize();
  },
  beforeDestroy() {
    this.resizeObserver.disconnect();
  },
  computed: {
    currentClueText(): string {
      return getCurrentClue(this.puzzle.getData()).text;
    },
    currentClueNumberType(): string {
      const clue = getCurrentClue(this.puzzle.getData());
      return `${clue.number} ${this.localization.get(clue.type).toUpperCase()} |`;
    },
  },
  watch: {
    currentClueText() {
      this.resize();
    },
  },
  methods: {
    resize(): void {
      const textContainer = this.$refs.textContainer as HTMLElement;
      const maxHeight = (this.$refs.mainContainer as HTMLElement).clientHeight;

      textContainer.style.fontSize = '';
      let currentHeight = textContainer.clientHeight;
      let currentFontSize = 1;

      while (currentHeight > maxHeight) {
        currentHeight = textContainer.clientHeight;
        currentFontSize -= 0.1;
        textContainer.style.fontSize = `${currentFontSize}em`;
      }
    },
    changeClue(indexChange: number): void {
      indexChange < 0 ? (this.leftAnimated = true) : (this.rightAnimated = true);
      this.puzzle.changeClue(indexChange);
    },
  },
  render() {
    return (
      <div class={{
        "currentClueBar": true,
        "currentClueBar--mobile": !OS.desktop,
      }} ref='mainContainer'>
        <div class={{
          "currentClueBar__wrapper": true,
          "currentClueBar__wrapper--hidden": this.hidden,
        }}>
          <div
            onClick={() => this.changeClue(-1)}
            class={{
              "currentClueBar__arrowWrapper": true,
              "currentClueBar__arrowWrapper--clickAnimation": this.leftAnimated,
            }}
            onAnimationend={() => this.leftAnimated = false}
          >
            <img src='images/Arrow_Grey.svg' class='currentClueBar__arrow currentClueBar__arrow--rotated'/>
          </div>

          <div class='currentClueBar__textWrapper' onClick={() => this.puzzle.toggleDirection()}>
            <div class='currentClueBar__text' ref='textContainer'>
              <span style='font-weight: bold'>
                { this.currentClueNumberType }
              </span>
              &nbsp;
              <span>
                { this.currentClueText }
              </span>
            </div>
          </div>

          <div
            onClick={() => this.changeClue(1)}
            class={{
              "currentClueBar__arrowWrapper": true,
              "currentClueBar__arrowWrapper--clickAnimation": this.rightAnimated,
            }}
            onAnimationend={() => this.rightAnimated = false}
          >
            <img src='images/Arrow_Grey.svg' class='currentClueBar__arrow'/>
          </div>
        </div>
      </div>
    );
  },
});
